// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-flex-row {
    display: flex;
  }
  
  .common-flex-col {
    display: flex;
    flex-direction: column;
  }
  
  .align-center {
    align-items: center;
  }
  .align-end {
    align-items: flex-end;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .margin-t {
    margin-top: 1rem;
  }
  /* user creation */
  .user-creation-form {
    background-color: white;
  }
  
  .add-btns {
    gap: 1rem;
  }
  
  .main-container {
    /* display: grid;
    grid-template-columns: 1fr 7fr;
    justify-content: space-around;
    padding-top: 1rem; */
    position: fixed;
    padding: 1rem 1rem;
    width: 100%;
    display: flex;
    gap: 1rem;
  }
  
  /* roles form  */
  .roles-input {
    gap: 0.5rem;
  }
  
  .menu-style {
    height: 100vh;
    width: 200px;
    position: fixed;
    background-color: rebeccapurple;
  }
  
  #form-input-container {
    display: flex;
    flex-direction: column;
  }
  
  .validation-text {
    position: absolute;
    color: #faad14;
    bottom: -1.2rem;
    left: 0;
  }
  .validation-text-roles{
    margin-top: 0.5rem;
    color:#faad14;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
  
  @media screen and (max-width: 600px) {
    .main-container {
      display: flex;
      flex-direction: column;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Components/Management/ManageUsers/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA,kBAAkB;EAClB;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE;;;wBAGoB;IACpB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,SAAS;EACX;;EAEA,gBAAgB;EAChB;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,eAAe;IACf,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,OAAO;EACT;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;;IAEE,wBAAwB;IACxB,SAAS;EACX;;EAEA,YAAY;EACZ;IACE,0BAA0B;EAC5B;;EAEA;IACE;MACE,aAAa;MACb,sBAAsB;IACxB;EACF","sourcesContent":[".common-flex-row {\n    display: flex;\n  }\n  \n  .common-flex-col {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .align-center {\n    align-items: center;\n  }\n  .align-end {\n    align-items: flex-end;\n  }\n  .justify-center {\n    justify-content: center;\n  }\n  .justify-end {\n    justify-content: flex-end;\n  }\n  .margin-t {\n    margin-top: 1rem;\n  }\n  /* user creation */\n  .user-creation-form {\n    background-color: white;\n  }\n  \n  .add-btns {\n    gap: 1rem;\n  }\n  \n  .main-container {\n    /* display: grid;\n    grid-template-columns: 1fr 7fr;\n    justify-content: space-around;\n    padding-top: 1rem; */\n    position: fixed;\n    padding: 1rem 1rem;\n    width: 100%;\n    display: flex;\n    gap: 1rem;\n  }\n  \n  /* roles form  */\n  .roles-input {\n    gap: 0.5rem;\n  }\n  \n  .menu-style {\n    height: 100vh;\n    width: 200px;\n    position: fixed;\n    background-color: rebeccapurple;\n  }\n  \n  #form-input-container {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .validation-text {\n    position: absolute;\n    color: #faad14;\n    bottom: -1.2rem;\n    left: 0;\n  }\n  .validation-text-roles{\n    margin-top: 0.5rem;\n    color:#faad14;\n  }\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  \n  /* Firefox */\n  input[type=\"number\"] {\n    -moz-appearance: textfield;\n  }\n  \n  @media screen and (max-width: 600px) {\n    .main-container {\n      display: flex;\n      flex-direction: column;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
